function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "id2"
}, /*#__PURE__*/React.createElement("path", {
  d: "m529 455h17.637v65h-17.637z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "id3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m298.65 345.23h229.35v292.77h-229.35z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m234.65 271.98c0 1.707-1.4023 3.1094-3.1094 3.1094h-17.035c-1.7109 0-3.1094-1.4024-3.1094-3.1094v-155.6c0-1.707 1.3984-3.1094 3.1094-3.1094h17.035c1.707 0 3.1094 1.4024 3.1094 3.1094v155.6",
  fill: "#00a499"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
}, /*#__PURE__*/React.createElement("path", {
  d: "m234.65 271.98c0 1.707-1.4024 3.1094-3.1094 3.1094h-17.035c-1.711 0-3.1094-1.4023-3.1094-3.1094v-155.6c0-1.707 1.3984-3.1094 3.1094-3.1094h17.035c1.707 0 3.1094 1.4024 3.1094 3.1094z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m234.65 100.79c0-1.707-1.4024-3.1055-3.1094-3.1055h-17.035c-1.711 0-3.1094 1.3984-3.1094 3.1055v9.3789c0 1.707 1.3984 3.1016 3.1094 3.1016h17.035c1.707 0 3.1094-1.3945 3.1094-3.1016z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m224.63 304.02c-0.84375 1.4922-2.2227 1.4922-3.0703 4e-3l-6.4336-11.328c-0.84376-1.4844-1.5391-4.0976-1.5391-5.8047v-8.6992c0-1.707 1.4024-3.1016 3.1094-3.1016h12.645c1.707 0 3.1055 1.3945 3.1055 3.1016v8.8828c0 1.707-0.68751 4.3242-1.5312 5.8125z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-298.93 -345.23)",
  clipPath: "url(#id2)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.10956 0 0 -.10961 189.72 734.34)",
  d: "m3126.9 2515.9h70.988c15.581 0 28.31-12.758 28.31-28.332v-496.51",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 60
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-298.93 -345.23)",
  clipPath: "url(#id3)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.10956 0 0 -.10961 189.72 734.34)",
  d: "m2934.6 909.45h-1880.4c-15.581 0-28.31 12.794-28.31 28.368v2554.2c0 15.61 12.729 28.332 28.31 28.332h1966.6c15.617 0 28.381-12.723 28.381-28.332v-827.13",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 60
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m100.31 55.992c0 1.7148-1.3945 3.1094-3.1055 3.1094h-63.844c-1.7148 0-3.1094-1.3945-3.1094-3.1094v-9.6172c0-1.707 1.3945-3.1016 3.1094-3.1016h63.844c1.7109 0 3.1055 1.3945 3.1055 3.1016v9.6172",
  fill: "#00a499"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m100.31 55.993c0 1.7148-1.3945 3.1094-3.1055 3.1094h-63.844c-1.7149 0-3.1094-1.3945-3.1094-3.1094v-9.6172c0-1.707 1.3945-3.1016 3.1094-3.1016h63.844c1.7109 0 3.1055 1.3945 3.1055 3.1016zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m100.31 90.5c0 1.707-1.3945 3.1016-3.1055 3.1016h-63.844c-1.7148 0-3.1094-1.3945-3.1094-3.1016v-9.6172c0-1.7109 1.3945-3.1094 3.1094-3.1094h63.844c1.7109 0 3.1055 1.3984 3.1055 3.1094v9.6172",
  fill: "#00a499"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m100.31 90.501c0 1.707-1.3945 3.1016-3.1055 3.1016h-63.844c-1.7149 0-3.1094-1.3945-3.1094-3.1016v-9.6172c0-1.7109 1.3945-3.1094 3.1094-3.1094h63.844c1.7109 0 3.1055 1.3984 3.1055 3.1094zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m100.31 125c0 1.707-1.3945 3.1094-3.1055 3.1094h-63.844c-1.7148 0-3.1094-1.4023-3.1094-3.1094v-9.6172c0-1.707 1.3945-3.1094 3.1094-3.1094h63.844c1.7109 0 3.1055 1.4023 3.1055 3.1094v9.6172",
  fill: "#00a499"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m100.31 125c0 1.707-1.3945 3.1094-3.1055 3.1094h-63.844c-1.7149 0-3.1094-1.4024-3.1094-3.1094v-9.6172c0-1.707 1.3945-3.1094 3.1094-3.1094h63.844c1.7109 0 3.1055 1.4023 3.1055 3.1094zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m100.31 159.5c0 1.707-1.3945 3.1094-3.1055 3.1094h-63.844c-1.7148 0-3.1094-1.4023-3.1094-3.1094v-9.6172c0-1.707 1.3945-3.1016 3.1094-3.1016h63.844c1.7109 0 3.1055 1.3945 3.1055 3.1016v9.6172",
  fill: "#00a499"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m100.31 159.5c0 1.707-1.3945 3.1094-3.1055 3.1094h-63.844c-1.7149 0-3.1094-1.4023-3.1094-3.1094v-9.6172c0-1.707 1.3945-3.1016 3.1094-3.1016h63.844c1.7109 0 3.1055 1.3945 3.1055 3.1016zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m100.31 194c0 1.7148-1.3945 3.1094-3.1055 3.1094h-63.844c-1.7148 0-3.1094-1.3945-3.1094-3.1094v-9.6094c0-1.7109 1.3945-3.1055 3.1094-3.1055h63.844c1.7109 0 3.1055 1.3945 3.1055 3.1055v9.6094",
  fill: "#00a499"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
}, /*#__PURE__*/React.createElement("path", {
  d: "m100.31 194c0 1.7148-1.3945 3.1094-3.1055 3.1094h-63.844c-1.7149 0-3.1094-1.3945-3.1094-3.1094v-9.6094c0-1.7109 1.3945-3.1055 3.1094-3.1055h63.844c1.7109 0 3.1055 1.3945 3.1055 3.1055z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.08 44.052h64.695"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.08 63.083h64.695"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.08 82.118h64.695"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.08 101.16h64.695"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.08 120.19h64.695"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.08 139.23h64.695"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.08 158.26h64.695"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.08 177.3h64.695"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.08 196.34h64.695"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m56.659 245.34c0 1.7148-1.3945 3.1094-3.1055 3.1094h-14.242c-1.707 0-3.1055-1.3945-3.1055-3.1094v-14.246c0-1.7109 1.3984-3.1094 3.1055-3.1094h14.242c1.7109 0 3.1055 1.3984 3.1055 3.1094v14.246",
  fill: "#00a499"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m56.659 245.34c0 1.7148-1.3945 3.1094-3.1055 3.1094h-14.242c-1.707 0-3.1055-1.3945-3.1055-3.1094v-14.246c0-1.7109 1.3984-3.1094 3.1055-3.1094h14.242c1.7109 0 3.1055 1.3984 3.1055 3.1094zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m99.795 245.66c0 1.707-1.4023 3.1055-3.1094 3.1055h-14.242c-1.7109 0-3.1055-1.3984-3.1055-3.1055v-14.25c0-1.7109 1.3945-3.1094 3.1055-3.1094h14.242c1.707 0 3.1094 1.3984 3.1094 3.1094v14.25",
  fill: "#00a499"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m99.796 245.66c0 1.707-1.4023 3.1055-3.1094 3.1055h-14.242c-1.7109 0-3.1055-1.3984-3.1055-3.1055v-14.25c0-1.7109 1.3945-3.1094 3.1055-3.1094h14.242c1.707 0 3.1094 1.3984 3.1094 3.1094zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m142.92 245.98c0 1.7109-1.3984 3.1055-3.1094 3.1055h-14.242c-1.707 0-3.1055-1.3945-3.1055-3.1055v-14.25c0-1.7109 1.3984-3.1055 3.1055-3.1055h14.242c1.7109 0 3.1094 1.3945 3.1094 3.1055v14.25",
  fill: "#00a499"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m142.92 245.98c0 1.7109-1.3984 3.1054-3.1094 3.1054h-14.242c-1.707 0-3.1055-1.3945-3.1055-3.1054v-14.25c0-1.7109 1.3984-3.1055 3.1055-3.1055h14.242c1.7109 0 3.1094 1.3945 3.1094 3.1055zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m186.05 246.29c0 1.7109-1.3984 3.1055-3.1055 3.1055h-14.242c-1.7109 0-3.1094-1.3945-3.1094-3.1055v-14.25c0-1.707 1.3984-3.1055 3.1094-3.1055h14.242c1.707 0 3.1055 1.3984 3.1055 3.1055v14.25",
  fill: "#00a499"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m186.05 246.29c0 1.7109-1.3984 3.1055-3.1055 3.1055h-14.242c-1.711 0-3.1094-1.3945-3.1094-3.1055v-14.25c0-1.707 1.3984-3.1055 3.1094-3.1055h14.242c1.707 0 3.1055 1.3984 3.1055 3.1055zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.575
});

function SvgIntroFormIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329.94,
    height: 410.92,
    viewBox: "0 0 247.58 308.42",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFormIcon1);
export default __webpack_public_path__ + "static/media/introFormIcon1.8cc6ba13.svg";
export { ForwardRef as ReactComponent };